/** @format */

const template = `
<div class="modal-header">
  <h2 class="modal-title" translate>SIS_COMPONENTS.COURSE_UNIT_REALISATION.ADD_NEW_CUR_MODAL.ADD_NEW_COURSE_UNIT_REALISATION</h2>
</div>
<div class="modal-body">
  <form name="curCreateForm" valdr-type="CourseUnitRealisation" valdr-validation-groups="ctrl.validationGroups">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label label-required="universityOrgIds" class="control-label" translate
            >SIS_COMPONENTS.COURSE_UNIT_REALISATION.ADD_NEW_CUR_MODAL.SELECT_UNIVERSITY</label
          >
          <referred-object-select-editor
            name="universitySelector"
            id="ctrl.selectedUniversityId"
            model="ctrl.universityModel"
            required="true"
            allow-clear="false"
            on-select="ctrl.selectUniversity(obj)">
          </referred-object-select-editor>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label label-required="activityPeriod" class="control-label" translate
            >SIS_COMPONENTS.COURSE_UNIT_REALISATION.ADD_NEW_CUR_MODAL.SELECT_CURRICULUM_PERIOD</label
          >
          <referred-object-select-editor
            name="curriculumPeriodSelector"
            id="ctrl.selectedCurriculumPeriod.id"
            model="ctrl.curriculumPeriodModel"
            university-org-id="ctrl.selectedUniversityId"
            required="true"
            allow-clear="false"
            on-select="ctrl.selectCurriculumPeriod(obj)"
            reversed-order="true">
          </referred-object-select-editor>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <assessment-item-selector
          selected-course-unit="ctrl.selectedCourseUnit"
          selected-assessment-item="ctrl.selectedAssessmentItem"
          selected-curriculum-period="ctrl.selectedCurriculumPeriod"
          assessment-item-service="ctrl.assessmentItemService"
          course-unit-service="ctrl.courseUnitService"
          required="{{::ctrl.courseUnitRealisationConstraints.assessmentItemIds['jakarta.validation.constraints.NotEmpty']}}">
        </assessment-item-selector>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label label-required="courseUnitRealisationTypeUrn" translate>TEACHING.COURSE_UNIT_REALISATION_CLASSIFICATION.TYPE</label>
          <sis-code-select-editor
            name="courseUnitRealisationTypeUrn"
            id="ctrl.selectedCourseUnitRealisationTypeUrn"
            [codebook-urn]="'urn:code:course-unit-realisation-type'"
            [selected-urn]="ctrl.selectedCourseUnitRealisationTypeUrn"
            [required]="true"
            [show-errors]="true"
            (on-select-code)="ctrl.setCourseUnitRealisationTypeUrn(curCreateForm, $event.selectedUrn)">
          </sis-code-select-editor>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-9 col-sm-6 col-lg-5">
        <sis-basic-grouping-panel heading="SIS_COMPONENTS.COURSE_UNIT_REALISATION.ADD_NEW_CUR_MODAL.ACTIVITY_PERIOD">
          <div class="form-group">
            <local-date-range-editor
              name="activityPeriod"
              ng-model="ctrl.courseUnitRealisation.activityPeriod"
              end-date-required="true"
              start-date-required="true">
            </local-date-range-editor>
          </div>
        </sis-basic-grouping-panel>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-hollow btn-lg" type="button" ng-click="ctrl.cancel()" translate>SIS_COMPONENTS.BUTTON.CANCEL</button>

  <button class="btn btn-primary btn-lg" type="button" ng-disabled="!ctrl.isFormValid(curCreateForm)" ng-click="ctrl.ok()" translate
    >SIS_COMPONENTS.BUTTON.SAVE</button
  >
</div>
`;
export default template;
